__turbopack_context__.v({
  "inverse": "RatingNumber-module__NqiDXG__inverse",
  "ratingNumber": "RatingNumber-module__NqiDXG__ratingNumber",
});
